import React, {useState, useEffect, useContext} from 'react';
import i18n from '../../../../i18n';


export default function Instruction() {
    return (
        <>
            <p className={"content-header"}>Инструкции</p>
            <p>В настоящий момент на сайте доступны инструкции:</p>
            <ol>
                <li>
                    <a target="_blank" href="/instructions/Инструкция для грузовладельцев.pdf" download>{i18n.t(`main.instructions.forConsignor`)}</a>
                </li>
                <li>
                    <a target="_blank" href="/instructions/Инструкция для перевозчиков.pdf" download>{i18n.t(`main.instructions.forCarrier`)}</a>
                </li>
            </ol>
        </>
    )
}